import {initializeFileHandler, removeFile} from './shared/uploader_utils';

let allInsuranceDocuments = []

window.reloadInsuranceDocumentUploader = (scope) => {
  const root = scope || document;
  // Target the container where Cocoon inserts nested fields
  const container = root.querySelector('#insurance-documents-container');

  if (!container) {
    return;
  }

  initializeInsuranceDocumentHandler('insurance-documents', allInsuranceDocuments, root);
  bindInsuranceDocumentRemoveEvent(container, allInsuranceDocuments);

  // Initialize MutationObserver
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      mutation.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          const uploadContainer = node.querySelector('.upload-form.file-upload-area');
          const fileField = node.querySelector('input[type="file"]');
          const previewsContainer = root.querySelector('[data-preview=insurance-documents-preview]');

          if (uploadContainer && fileField && previewsContainer) {
            // Small delay to ensure DOM is ready
            setTimeout(function() {
              initializeFileHandler(uploadContainer, fileField, previewsContainer, allInsuranceDocuments);
            }, 100);
          }
        }
      });
    });
  });

  // Start observing the container for child additions
  observer.observe(container, { childList: true, subtree: true });
}

function initializeInsuranceDocumentHandler(attachmentName, selectionList, root) {
  const searchRoot = root || document;
  const container = searchRoot.querySelector(`#${attachmentName}-container`);
  // Initialize handlers for existing permit file fields
  const permitFileForms = container.querySelectorAll('.nested-fields.form-card');

  permitFileForms.forEach(function(form) {
    const uploadContainer = form.querySelector('.upload-form.file-upload-area');
    const fileField = form.querySelector('input[type="file"]');
    const previewsContainer = container.querySelector(`[data-preview=${attachmentName}-preview]`);

    if (uploadContainer && fileField && previewsContainer) {
      initializeFileHandler(uploadContainer, fileField, previewsContainer, selectionList);
    }
  });
}

function bindInsuranceDocumentRemoveEvent(container, selectionList) {
  container.querySelectorAll('.file-preview').forEach(filePreview => {
    filePreview.addEventListener('click', (e) => removeFile(e, selectionList));
  })
}

document.addEventListener('turbolinks:load', function() {
  reloadInsuranceDocumentUploader();
});
